'use client';
import React from 'react';
import { Layout } from 'antd';
import styles from './Welcome.module.scss';
import { TitleBlock } from './ui/TitleBlock';
import { ImageBlock } from './ui/ImageBlock';
import { StatsBlock } from './ui/StatsBlock';

const { Content } = Layout;

export function Welcome() {
  return (
    <Content className={styles.root}>
      <section className={styles.root_main}>
        <TitleBlock />
        <ImageBlock />
      </section>
      <StatsBlock />
    </Content>
  );
}
